import * as yup from 'yup'

export const validateUpdateProductRecipes = yup.object().shape({
    recipe_id:yup
    .string()
    .min(1, 'LA RECETA debe tener más de 1 caracteres'),
})


